<template>
  <v-row justify="center">
    <v-dialog v-model="open" ref="ABCD" scrollable max-width="500px">
      <v-card>
        <v-card-title>Share this campaign with</v-card-title>
        <v-divider></v-divider>
        <div class="pa-4">
          <v-autocomplete
              autocomplete
              v-model="searchAdmin"
              :loading="loading"
              :items="shareToList"
              @keyup="getAdminUsers(search)"
              :search-input.sync="search"
              label="Please enter email id"
            ></v-autocomplete>
            <span slot=“no-options”> </span>
          <!-- <v-autocomplete
            autocomplete
            v-model="searchAdmin"
            :items="shareToList"
            @keyup.stop="getAdminUsers(search)"
            :search-input.sync="search"
            class="mx-4"
            label="Add employee"
          ></v-autocomplete> -->
        </div>
        <!-- <v-divider></v-divider> -->
        <v-card-text style="height: 300px;" class="pa-0 px-4">
          <v-list v-if="(shareData && shareData.length > 0) || (adminData && adminData.length > 0)">
            The following users have access to this survey ({{totalLength}} user(s))
            <v-list-item-group
            >
              <template v-for="(item, index) in shareData">
                <v-list-item :key="item.id"  style="cursor: text;">
                  <v-list-item-content class="py-0">
                    <v-list-item-title>
                      <v-row>
                        <v-col cols="1" style="min-width:11%;">
                          <v-avatar class="mr-2" color="primary" size="35">
                            <span class="white--text headline small-text-headline">
                              {{item.shared_with.display_name.charAt(0)}}
                            </span>
                          </v-avatar>
                        </v-col>
                        <v-col cols="11" style="max-width:89%;">
                          {{item.shared_with.display_name}} <br>{{item.shared_with.email}}
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-btn color="primary" small outlined @click="deleteShare(item.id)">Revoke
                  </v-btn>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < shareToList.length"
                  :key="index"
                ></v-divider>
              </template>
              <template v-for="(item, index) in adminData">
                <v-list-item :key="item.id" style="cursor: text;">
                  <v-list-item-content class="py-0" >
                    <v-list-item-title>
                      <v-row>
                        <v-col cols="1" style="min-width:11%;">
                          <v-avatar class="mr-2" color="primary" size="35">
                            <span class="white--text headline small-text-headline">
                              {{item.display_name.charAt(0)}}
                            </span>
                          </v-avatar>
                        </v-col>
                        <v-col cols="11" style="max-width:89%;">
                          {{item.display_name}} <br>{{item.email}}
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-btn color="primary" disabled  text>Admin
                  </v-btn>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < adminData.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          <div
            v-if="adminData && adminData.length === 0"
            class="pa-4 d-flex align-center text-center"
          >
            No user found
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn text @click="open = false">Close</v-btn>
          <v-btn color="primary" @click="assignEmployee">Share</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
export default {
  name: 'AssignedTo',

  props: {
    campaignDetails: {
      required: true,
      type: Array
    },
    type: {
      required: false,
      type: String,
      default: 'employees'
    }
  },

  data () {
    return {
      open: false,
      selected: '',
      totalLength: '',
      searchAdmin: '',
      searchAssignedToUser: '',
      filteredUser: [],
      shareData: [],
      adminData: [],
      employee: null,
      shareToList: []
    };
  },

  watch: {
    open () {
      // reset the instance
      this.selected = '';
      this.searchAssignedTo();
    },
    campaignDetails () {
      this.infiniteHandler();
    }
  },
  mounted () {
    this.infiniteHandler();
    this.getAdminUsers();
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    deleteShare (id) {
      var that = this;
      if (that.campaignDetails.stage_id) {
        axios.delete(`${process.env.VUE_APP_ADHOC_API_URL}stage/${that.campaignDetails.stage_id}/share_settings/${id}`, {
        }).then((response) => {
          if (response) {
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Deleted successfully!'
            });
            this.infiniteHandler();
          }
        });
      }
    },
    getAdminUsers (search) {
      axios.get(`${process.env.VUE_APP_ADHOC_API_URL}user/admins_list`, {
        params: {
          raw_search_string: search
        }
      }).then((response) => {
        if (response && response.data.data && response.data.data.length > 0) {
          this.$lodash.each(response.data.data, (val) => {
            this.shareToList.push(val.email);
          });
        }
      });
    },
    searchAssignedTo () {
      const filter = this.shareToList;
      // eslint-disable-next-line max-len
      const tempData = filter.filter(r => r.text.toLowerCase().indexOf(this.searchAssignedToUser.toLowerCase()) >= 0);
      this.filteredUser = tempData;
    },
    infiniteHandler ($state) {
      var that = this;
      if (that.campaignDetails.stage_id) {
        axios.get(`${process.env.VUE_APP_ADHOC_API_URL}stage/${that.campaignDetails.stage_id}/share_settings/`, {
        }).then((response) => {
          if (response.data) {
            this.shareData = response.data.share_settings;
            this.adminData = response.data.admin_list;
            this.totalLength = response.data.share_settings.length + response.data.admin_list.length;
          }
        });
      }
    },
    assignEmployee () {
      // console.log(this.employee);
      const temp = {
        shared_with: this.searchAdmin,
        created_by: this.user.email,
        company: this.user.company,
        stage: this.campaignDetails.stage_id
      };
      // this.$emit('assignEmployee', data);
      axios.post(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.campaignDetails.stage_id}/share_settings/`, temp)
        .then((resp) => {
          if (resp.data) {
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Campaign shared successfully!'
            });
            this.$parent.infiniteHandler();
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Campaign shared successfully!'
            });
            this.testEmailData = false;
            this.testSmsData = false;
            if (this.testCampaigns) {
              this.reminder = {};
              this.closeModal();
            }
          }
        }, (resp) => {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to share campaign, Please try again later!'
          });
          throw new Error(resp.body);
        });
      this.$nextTick(() => {
        this.open = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.small-text-headline {
  font-size: 1.1rem !important;
}
</style>
